// extracted by mini-css-extract-plugin
export default {"header_wrap":"CustomBoxHeader_header_wrap__LQkCh","edit_btn":"CustomBoxHeader_edit_btn__9kf9I","title":"CustomBoxHeader_title__V6oNB"};